import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ory } from 'src/providers/authProvider';
import PageLoader from 'src/UI/loader/PageLoader';
import { GenericErrorPage } from 'src/error/GenericErrorPage';

export const redirectToLogin = async (useCustomFlow: boolean = false) => {
  if (useCustomFlow) {
    window.location.replace('/login');
  } else {
    const loginFlow = await ory.createBrowserLoginFlow({ refresh: true });
    window.location.replace(loginFlow.data.request_url);
  }
};

export const RedirectToLoginPage = () => {
  const { flagEnabledCustomSettingsFlow } = useFlags();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (flagEnabledCustomSettingsFlow === false) {
      redirectToLogin(false).catch(() => setIsError(true));
    }
  }, [flagEnabledCustomSettingsFlow]);

  if (flagEnabledCustomSettingsFlow) {
    return <Navigate to="/login" replace />;
  }

  return isError ? (
    <GenericErrorPage error={new Error('Failed creating browser login flow')} />
  ) : (
    <PageLoader />
  );
};
